import React from 'react'
import PropTypes from 'prop-types'
import { useTrustMarkers } from 'src/hooks/useTrustMarkers'
import { useFooterTrustMarkersCombination } from 'src/common/footerTrustMarkersContext'
import { FOOTER_TRUST_MARKERS_COMBINATION_ID } from 'src/common/constants/footerTrustMarkers'
import NewTrustMarkersWrapper from '../NewTrustMarkersWrapper'
import TrustMarkersPlaceholder from './TrustMarkersPlaceholder'

const DynamicTrustMarkers = ({
  combinationId = 'control',
  trustMarkersCombination: trustMarkersCombinationProp,
  title,
  isDynamic = true,
  logosGroup,
  isFooter = true,
  statusCode,
  desktopTitle,
  desktopTitleClassname,
  useGridLayout = false,
  LoadingComponent,
  ErrorComponent,
}) => {
  const footerTrustMarkersFromApp = useFooterTrustMarkersCombination()
  const isFooterCombination =
    combinationId?.toLowerCase() === FOOTER_TRUST_MARKERS_COMBINATION_ID

  const serverTrustMarkers =
    trustMarkersCombinationProp ??
    (isFooterCombination ? footerTrustMarkersFromApp : null)

  const { trustMarkers: clientTrustMarkers, isLoading: isClientLoading } =
    useTrustMarkers(combinationId, { enabled: !serverTrustMarkers })

  const trustMarkers = serverTrustMarkers ?? clientTrustMarkers
  const isLoading = serverTrustMarkers ? false : isClientLoading

  const logosGroupCount = logosGroup?.length ?? 0
  const showDesktopTitle = Boolean(desktopTitle)
  const hasLogosGroup = logosGroupCount > 0
  const placeholderProps = {
    useGridLayout,
    logosGroupCount,
    showDesktopTitle,
    hasLogosGroup,
  }

  if (isLoading) {
    if (LoadingComponent) {
      return <LoadingComponent />
    }

    return <TrustMarkersPlaceholder {...placeholderProps} />
  }

  if (!trustMarkers) {
    if (ErrorComponent) {
      return <ErrorComponent />
    }

    return null
  }

  return (
    <NewTrustMarkersWrapper
      trustMarkersCombination={trustMarkers}
      title={title}
      isDynamic={isDynamic}
      logosGroup={logosGroup}
      isFooter={isFooter}
      statusCode={statusCode}
      desktopTitle={desktopTitle}
      desktopTitleClassname={desktopTitleClassname}
      useGridLayout={useGridLayout}
    />
  )
}

DynamicTrustMarkers.propTypes = {
  combinationId: PropTypes.string,
  trustMarkersCombination: PropTypes.object,
  title: PropTypes.string,
  isDynamic: PropTypes.bool,
  logosGroup: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      img: PropTypes.string,
      url: PropTypes.string,
      widget: PropTypes.object,
      alt: PropTypes.string,
      component: PropTypes.elementType,
    })
  ),
  isFooter: PropTypes.bool,
  statusCode: PropTypes.number,
  desktopTitle: PropTypes.string,
  desktopTitleClassname: PropTypes.string,
  useGridLayout: PropTypes.bool,
  LoadingComponent: PropTypes.elementType,
  ErrorComponent: PropTypes.elementType,
}

DynamicTrustMarkers.defaultProps = {
  combinationId: 'control',
  trustMarkersCombination: null,
  isDynamic: true,
  title: undefined,
  logosGroup: undefined,
  isFooter: true,
  statusCode: undefined,
  desktopTitle: 'CUSTOMER APPROVED, INDUSTRY RECOGNIZED',
  desktopTitleClassname: '',
  useGridLayout: false,
  LoadingComponent: null,
  ErrorComponent: null,
}

export default DynamicTrustMarkers
